// Quick-action href builders for CRM rows (WhatsApp / Email / Phone).
// All helpers return null when input is missing/blank so callers can hide
// the button entirely instead of rendering a broken anchor.

function normalizeIsraeliPhone(raw: string): string | null {
  const digits = raw.replace(/\D/g, '');
  if (digits.length === 0) return null;
  if (digits.startsWith('972')) return digits;
  if (digits.startsWith('0')) return `972${digits.slice(1)}`;
  return digits;
}

export function whatsappHref(phone: string | null | undefined): string | null {
  if (!phone) return null;
  const digits = normalizeIsraeliPhone(phone);
  if (!digits) return null;
  return `https://wa.me/${digits}`;
}

export function telHref(phone: string | null | undefined): string | null {
  if (!phone) return null;
  const digits = normalizeIsraeliPhone(phone);
  if (!digits) return null;
  return `tel:+${digits}`;
}

export function mailtoHref(email: string | null | undefined): string | null {
  if (!email) return null;
  const trimmed = email.trim();
  if (trimmed.length === 0) return null;
  return `mailto:${trimmed}`;
}
